<template>
  <div class="range-slider">
    <b-form-input
      :id="id"
      v-model="value_"
      data-testid="range-input"
      variant="secondary"
      class="range-slider__input"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      number
    />
    <div
      class="range-slider__footer"
      data-testid="range-footer"
    >
      <span
        v-for="option in rangeOptions"
        :key="'range-' + uid + option"
        class="range-slider__option"
        :class="{ 'range-slider__option-active': option === value_ }"
      >
        {{ option }}{{ suffix }}
      </span>
    </div>
  </div>
</template>

<script>
import { BFormInput } from '@ui/components'

export default {
  components: {
    BFormInput
  },
  props: {
    id: {
      type: String,
      required: false,
      default: null
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 100
    },
    step: {
      type: Number,
      required: false,
      default: 1,
      validator: num => num >= 0
    },
    modelValue: {
      type: Number,
      required: false,
      default: 0
    },
    suffix: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    uid() {
      return this.$uuid
    },
    value_: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    },
    rangeOptions() {
      const options = []
      for (let i = this.min; i <= this.max; i += this.step) {
        options.push(i % 1 ? i.toFixed(1) : i.toString())
      }
      return options
    }
  }
}
</script>

<style lang="scss">
@import "~@ui/styles/src/scss/utils/lib";

.range-slider {
  &__input {
    @mixin thumb() {
      position: relative;
      z-index: 1;
      background: $primaryColor;
    }

    @mixin thumb-active() {
      background: $blue-70;
    }

    @mixin thumb-focus() {
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem transparentize($primaryColor, 0.7);
    }

    &::-ms-thumb { @include thumb; }
    &::-moz-range-thumb { @include thumb; }
    &::-webkit-slider-thumb { @include thumb; }

    &:active::-ms-thumb { @include thumb-active; }
    &:active::-moz-range-thumb { @include thumb-active; }
    &:active::-webkit-slider-thumb { @include thumb-active; }

    &:focus::-ms-thumb { @include thumb-focus; }
    &:focus::-moz-range-thumb { @include thumb-focus; }
    &:focus::-webkit-slider-thumb { @include thumb-focus; }
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    margin: 0 -1%;
    margin-top: -22px;
    pointer-events: none;
  }

  &__option {
    width: 5%;
    padding-top: 16px;
    overflow: hidden;
    color: $grey-55;
    font-size: 10px;
    text-align: center;
    background-image: url("data:image/svg+xml,%3Csvg width='2' height='12' viewBox='0 0 2 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='0.920898' x2='0.920898' y2='12' stroke='%23EAEAEA'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: center top;
  }

  &__option-active {
    color: $grey-25;
  }
}
</style>
